<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >返佣配置</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增返佣配置"
      width="500px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
      
        <!-- <el-form-item label="用户ID：" prop="userId">
          <el-input-number
            :controls="false"
            v-model="detail.userId"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="币种：" prop="coin">
          <el-select v-model="detail.coin" placeholder="请选择">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额：" prop="amount">
          <el-input-number
            v-model="detail.amount"
            :controls="false"
            :min="0"
          ></el-input-number>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "PledgeCreate",
  data() {
    return {
      dialogVisible: false,
      detail: {},
      userType: "1",
      lists: [
        { label: "用户账号", value: "1" },
        { label: "用户ID", value: "2" },
      ],
      coinTypes: ["USDT", "SHIB", "BABYDOGE", "ETH"],
      rules: {
        userId: {
          required: true,
          message: "请填写转入的用户账号",
          trigger: "blur",
        },
        coin: {
          required: true,
          message: "请选择币种",
          trigger: "blur",
        },
        amount: {
          required: true,
          message: "请输入转账金额",
          trigger: "blur",
        },
      },
    };
  },
  computed: {
    // ...mapState('transferInner', ['coinTypes'])
    ...mapState('ctf',['coinList'])
  },
  mounted() {
    this.listAllCoin()
  },
  methods: {
    ...mapActions("commission", ["create", "transfer",'reqList']),
    ...mapActions('ctf', ['getCtflist', 'listAllCoin']),
    closeDialog() {
      
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    close() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
     

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
         const res =await this.transfer({...this.detail})
            if (res.code == 0) {
              this.$message({
                message: "转账成功！",
                type: "success",
              });
              this.$emit("refresh", {page: 1});
              this.dialogVisible = false;
            }
           
         ;
        }
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
